/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 503db119e280
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * Delivery types for assets generated by Cloudinary operations.
 */
export const GeneratedDeliveryType = {
  Multi: "multi",
  Sprite: "sprite",
  Text: "text",
  List: "list",
} as const;
/**
 * Delivery types for assets generated by Cloudinary operations.
 */
export type GeneratedDeliveryType = ClosedEnum<typeof GeneratedDeliveryType>;

export const GeneratedDeliveryType$zodSchema = z.enum([
  "multi",
  "sprite",
  "text",
  "list",
]).describe("Delivery types for assets generated by Cloudinary operations.");
